<div>
    <div class="d-flex flex-nowrap justify-content-between p-0 m-0">
        <button mat-icon-button (click)="backStep()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <button mat-icon-button (click)="onClose()">
            <mat-icon>close</mat-icon>
          </button>
    </div>
    <div class="content">
        <ng-template #container containerProcess></ng-template>
    </div>
    <div class="footer">
        <ng-container *ngIf="currentStep != 3; else cancelConfirm">
          <button class="w-100 btn-process" mat-stroked-button (click)="nextStep()" [disabled]="(currentStep == 2 && datosCancelacion == null)">
            {{labelCurrentStep}}
          </button> 
        </ng-container>
        <ng-template #cancelConfirm>
          <button class="w-100 btn-process d-flex justify-content-center align-items-center" mat-stroked-button (click)="toFinish()" [disabled]="(datosCancelacion?.firma == undefined || datosCancelacion?.firma == null || isLoading)">
            <ng-container *ngIf="!isLoading; else loading">
              CONFIRMAR CANCELACIÓN 
            </ng-container>
            <ng-template #loading>
              <mat-spinner [diameter]="20"></mat-spinner>
            </ng-template>
          </button> 
        </ng-template>
        
    </div>
</div>